import moment from 'moment';
const checkStatusTable: any = {
  Checking: '等待检测',
  Success: '检测成功',
  OutOfMoney: '余额不足',
  CheckFail: '检测失败',
  Error: '检测失败',
};
const checkTypeTable: any = {
  NPCheck: '新文献检测',
  PACheck: '已发表文献检测'
};
const checkStatus = (val: string) => {
  return checkStatusTable[val];
};
const checkType = (val: string) => {
  return checkTypeTable[val];
};
const formatTime = (val: string, format: string) => {
  const str = val ? moment(val).format(format) : '';
  return str;
};
const toString = (val: string[] = []) => {
  return val.join(',');
};
const secondFormat = (val: number) => {
  const momentObj = moment.duration(val, 'seconds');
  const hours = Math.floor(momentObj.asHours());
  const mins = Math.floor(momentObj.asMinutes()) - hours * 60;
  const seconds = val - hours * 3600 - mins * 60;
  let result = seconds + '秒';
  if (mins > 0) {
      result = mins + '分' + result;
  }
  if (hours > 0) {
      result = hours + '小时' + result;
  }
  return result;
};
const accountStatus = (val: number) => {
  return val === 1 ? '关闭' : '开通';
};
const upperLevel = (val: string) => {
  return val.split('.')[0];
};
const accountValidity = (val: string) => {
  const sevenDayTime = 60 * 60 * 24 * 7;
  const nowTime = moment().unix();
  const valTime = moment(val).unix();
  let classStr = '';
  const time = valTime - nowTime;
  if (time > 0 && time >= sevenDayTime) {
    classStr = '';
  } else if (time > 0) {
    classStr = 'orange';
  } else {
    classStr = 'red';
  }
  return classStr;
};
const checkStatusClass = (val: string) => {
  let classStr = '';
  if ( val === 'Success') {
    classStr = 'green';
  } else if ( val === 'CheckFail') {
    classStr = 'red';
  }else if ( val === 'Error') {
    classStr = 'red';
  } else {
    classStr = '';
  }
  return classStr;
};
const uploadFileStatusTable: any = {
  Success: '上传成功',
  SizeZero: '文本内容为空',
  SizeLimit: '文件大小超过30M',
  InvalidFiletype: '文件格式不符合要求',
  NotRegularName: '文件名包含无效字符',
  Error: '文本抽取失败'
};
const uploadFileStatus = (val: string) => {
  return uploadFileStatusTable[val];
};
export {
  checkStatus,
  checkType,
  formatTime,
  toString,
  secondFormat,
  accountStatus,
  upperLevel,
  accountValidity,
  checkStatusClass,
  uploadFileStatus
};
